import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { isEqual } from 'lodash';
import { IFiltersSliceState } from '../../filters/filtersSlice';
import { RootState } from '../../store';
import { getAttributesTable } from './attributesTableAPI';

export interface IAttributesTableAPIResponse {
  values: string;
  segmentName: string;
  segmentCategory: string;
  filters: string;
  surveyKey: string;
  data: IData;
  p2: IPeriodValues;
}

interface IAttributesTableComponentState {
  isLoading: boolean;
  hasError: boolean;
  apiResponse: IAttributesTableAPIResponse;
}

interface IData {
  [key: string]: IPeriodValues;
}

interface IPeriodValues {
  [key: string]: number | string;
}

const initialState: IAttributesTableComponentState = {
  isLoading: false,
  hasError: false,
  apiResponse: {
    values: '',
    segmentName: '',
    segmentCategory: '',
    filters: '',
    surveyKey: '',
    data: {},
    p2: {},
  },
};

export const loadAttributesTable = createAsyncThunk(
  'attributesTable/get',
  async (filters: IFiltersSliceState) => {
    const response = await getAttributesTable(filters);
    return response;
  }
);

export const attributesTableComponentSlice = createSlice({
  name: 'attributesTable',
  initialState,
  reducers: {
    updateAttributesTableState: (
      state: IAttributesTableComponentState,
      action
    ) => {
      const apiResponse = action.payload;
      if (!isEqual(state, apiResponse)) {
        state.apiResponse = apiResponse;
      }
      return state;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(loadAttributesTable.pending, (state) => {
      state.isLoading = true;
      state.hasError = false;
    });
    builder.addCase(loadAttributesTable.fulfilled, (state, action) => {
      if (action.payload) {
        state.apiResponse = action.payload;
        state.isLoading = false;
        state.hasError = false;
      }
    });
    builder.addCase(loadAttributesTable.rejected, (state, action) => {
      state.isLoading = false;
      if (action.error?.name !== 'AbortError') {
        state.hasError = true;
      }
    });
  },
});
export const selectAttributesTableState = (state: RootState) =>
  state.attributesTable;
export default attributesTableComponentSlice.reducer;
